import { GzMultiSelectItemWebComponent } from './component/GzMultiSelectItemWebComponent';
import { GzMultiSelectGroupWebComponent } from './component/GzMultiSelectGroupWebComponent';
import { WEB_COMPONENT_GZ_MULTISELECT_ITEM, WEB_COMPONENT_GZ_MULTISELECT_GROUP } from '../../webcomponents.constants';

export { GzMultiSelectItemWebComponent, GzMultiSelectGroupWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_MULTISELECT_ITEM, GzMultiSelectItemWebComponent);
window.customElements.define(WEB_COMPONENT_GZ_MULTISELECT_GROUP, GzMultiSelectGroupWebComponent);
